import React, { useCallback, useState } from "react";
import QrCode2Icon from "@mui/icons-material/QrCode2";

import { MachineQrCodeDialog } from "./MachineQrCodeDialog";
import { LogMachineData } from "../../Widgets/Log/log.typing";

interface MachineQrCodeButtonProps {
  machineId: string | null | undefined;
  fallbackMachine?: Partial<LogMachineData> | null;
}

/**
 * The QR code icon next to the edit machine button in the log header.
 * Opens the machine QR code popover.
 */
export const MachineQrCodeButton: React.FC<MachineQrCodeButtonProps> = ({
  machineId,
  fallbackMachine,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      setIsOpen(true);
    },
    []
  );

  const close = useCallback(() => setIsOpen(false), []);

  if (!machineId) {
    return null;
  }

  return (
    <>
      <span
        className="pointer"
        role="button"
        aria-label="Machine QR code"
        title="Machine QR code"
        onClick={open}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "44px",
          height: "44px",
          minWidth: "44px",
          marginLeft: "4px",
          marginTop: "-10px",
          flexShrink: 0,
          opacity: 0.85,
        }}
      >
        <QrCode2Icon style={{ fontSize: "20px" }} />
      </span>

      <MachineQrCodeDialog
        open={isOpen}
        machineId={machineId}
        fallbackMachine={fallbackMachine}
        onClose={close}
      />
    </>
  );
};

export default MachineQrCodeButton;
